import React, { FC, useEffect } from 'react';
import moment from 'moment';
import { useTranslations } from '@lang';
import { ParsedJourneyParams } from '@store/yourJourney/selectors';
import { ListPage } from '@common/features/List';
import { useRoomPageSettings } from '@common/features/rooms';
import { useRouter } from 'shared-routing';
import { Routes } from '@common/constants';
import useRooms from './useRooms';

type RoomsProps = {
  journeyParams: ParsedJourneyParams;
  changeJourneyParam: (paramName: string, value: any) => void;
  language: string;
};

export const Rooms: FC<RoomsProps> = ({ journeyParams, language, changeJourneyParam }) => {
  const router = useRouter();
  const { t } = useTranslations();
  const { content, isFetching: isFetchingContent } = useRoomPageSettings(
    language,
    t('common.room')
  );

  const { rooms, isFetching } = useRooms(journeyParams);

  useEffect(() => {
    if (router.query.fromDate && moment(router.query.fromDate).isBefore(moment().startOf('day'))) {
      router.replace(
        {
          pathname: router.pathname,
          query: { ...router.query, fromDate: moment().format('YYYY-MM-DD').toString() },
        },
        '',
        { shallow: true }
      );
    }
  }, []);

  const isLoading = isFetching || isFetchingContent;

  return (
    <ListPage
      journeyParams={journeyParams}
      onChangeJourneyParams={(params) => {
        changeJourneyParam('fromDate', params.fromDate as string);
        changeJourneyParam('spaDate', params.fromDate as string);
        changeJourneyParam('toDate', params.toDate as string);
        changeJourneyParam(
          'adults',
          (params.rooms || []).reduce((acc, room) => acc + room.adults, 0) ?? params.adults
        );
        changeJourneyParam(
          'children',
          (params.rooms || []).reduce((acc, room) => acc + room.children, 0) ?? params.children
        );
        changeJourneyParam('childAges', params.childAges);
        changeJourneyParam('rooms', params.rooms);
        const {
          promoRateCode: _promoRateCode,
          childAges: _childAges,
          rooms: _rooms,
          ...queryParams
        } = params;
        router.push({ pathname: Routes.ROOM_LIST, query: queryParams as any });
      }}
      title={content.title}
      description={content.description}
      items={rooms}
      isFetching={isLoading}
      acceptPromoRateCode={false}
    />
  );
};
